



























import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ColorPicker extends Vue {
    @Prop({
        default: () => [
            '#f93251',
            '#9c9d97',
            '#474f52',
            '#1d1c21',
            '#ffd83d',
            '#f9801d',
            '#b02e26',
            '#825432',
            '#80c71f',
            '#5d7c15',
            '#3ab3da',
            '#169c9d',
            '#3c44a9',
            '#f38caa',
            '#c64fbd',
            '#8932b7',
        ],
    })
    readonly swatches!: string[];

    @Prop({ default: null }) readonly placeholder!: string | null;

    @ModelSync('value', 'change', { type: String, default: '#f9ffff' })
    readonly formValue!: string;

    show = false;

    select(swatch: string): void {
        this.show = false;
        this.$emit('change', swatch);
        this.close();
    }

    toggle(): void {
        this.show = !this.show;
    }

    close(): void {
        this.show = false;
    }
}
